var _mask, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMiniMantenimientoResting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "m7cjmb7f4a",
    width: 25,
    height: 20,
    x: 8,
    y: 10,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.649 10.811h23.783v19.042H8.65V10.811z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#m7cjmb7f4a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M26.603 22.055c0 .272-.22.493-.493.493h-.894c-.117.566-.344 1.088-.642 1.561l.632.627c.192.193.193.505 0 .698l-.742.745c-.095.097-.223.145-.349.145-.125 0-.25-.047-.347-.143l-.614-.612c-.479.314-1.017.545-1.595.67v.86c0 .272-.22.492-.493.492h-1.051c-.273 0-.494-.22-.494-.493v-.859c-.573-.125-1.108-.355-1.584-.665l-.613.613c-.097.096-.223.145-.348.145-.127 0-.253-.049-.35-.145l-.743-.744c-.193-.192-.193-.505 0-.697l.629-.628c-.3-.476-.529-1.001-.647-1.57h-.894c-.271 0-.492-.221-.492-.493v-1.052c0-.272.22-.493.492-.493h.927c.126-.551.346-1.066.644-1.525l-.666-.664c-.193-.192-.193-.504-.002-.697l.744-.745c.096-.096.222-.145.348-.145.125 0 .252.048.348.143l.68.678c.464-.293.975-.514 1.527-.634v-.96c0-.273.221-.494.494-.494h1.051c.273 0 .493.22.493.493v.961c.55.12 1.059.338 1.52.63l.68-.68c.096-.096.22-.144.347-.144.127 0 .253.048.35.144l.743.744c.193.193.193.504 0 .696l-.665.665c.302.462.523.98.65 1.534h.926c.272 0 .493.22.493.493v1.052zm5.368-3.719L21.13 10.991c-.356-.24-.822-.24-1.176 0L9.11 18.336c-.48.326-.606.978-.28 1.458.324.48.98.605 1.456.28l2.239-1.516c-.012.076-.03.152-.03.231v9.606c0 .805.655 1.458 1.46 1.458h13.17c.806 0 1.46-.653 1.46-1.458v-9.606c0-.079-.017-.154-.028-.231l2.238 1.516c.18.122.384.18.587.18.336 0 .667-.161.87-.46.325-.48.2-1.132-.28-1.458z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M20.54 19.763c-.993 0-1.8.809-1.8 1.802s.807 1.801 1.8 1.801c.994 0 1.803-.808 1.803-1.8 0-.994-.809-1.803-1.802-1.803",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMiniMantenimientoResting);
export default __webpack_public_path__ + "static/media/icon_mini_mantenimiento_resting.b36f5ff0165fb706167d7181bcc8ff5f.svg";
export { ForwardRef as ReactComponent };